import { GetHouseholds } from "../../../types/api"
import { mergeMapHouseholds } from "../../../utils/mergeMapHouseholds";
import { Households } from "../../../types/types"
import { InferActionsTypes } from "./../index"

export const actionTypes = {
  GET_HOUSEHOLDS_FOR_DOWNLOAD_TRIGGER: "GET_HOUSEHOLDS_FOR_DOWNLOAD_TRIGGER",
  GET_HOUSEHOLDS_FOR_DOWNLOAD: "GET_HOUSEHOLDS_FOR_DOWNLOAD",
  GET_HOUSEHOLDS_TRIGGER: "GET_HOUSEHOLDS_CATEGORIES_TRIGGER",
  GET_HOUSEHOLDS_TRIGGER_FOR_MAP: "GET_HOUSEHOLDS_TRIGGER_FOR_MAP",
  GET_HOUSEHOLDS_TRIGGER_FOR_MAP_SUCCESS: "GET_HOUSEHOLDS_TRIGGER_FOR_MAP_SUCCESS",
  GET_HOUSEHOLDS_TRIGGER_FOR_MAP_ERROR: "GET_HOUSEHOLDS_TRIGGER_FOR_MAP_ERROR",
  // Fired by useGeocodingPinRefresh when the number of households carrying a map
  // pin has GROWN while the map was open — i.e. the background geocoder resolved
  // more addresses. Bumps the same refresh token a direct address edit does, which
  // clears the map's cached-viewport box and forces a real refetch.
  REFRESH_MAP_PINS: "REFRESH_MAP_PINS",
  SET_HOUSEHOLDS_OFFLINE_SNAPSHOT: "SET_HOUSEHOLDS_OFFLINE_SNAPSHOT",
  SET_HOUSEHOLD_DETAILS_OFFLINE_SNAPSHOT: "SET_HOUSEHOLD_DETAILS_OFFLINE_SNAPSHOT",
  USE_OFFLINE_HOUSEHOLD: "USE_OFFLINE_HOUSEHOLD",
  MERGE_HOUSEHOLD_DETAIL: "MERGE_HOUSEHOLD_DETAIL",
  GET_HOUSEHOLD_TRIGGER: "GET_HOUSEHOLD_TRIGGER",
  CREATE_HOUSEHOLD_TRIGGER: "CREATE_HOUSEHOLD_TRIGGER",
  UPDATE_HOUSEHOLD_TRIGGER: "UPDATE_HOUSEHOLD_TRIGGER",
  DELETE_HOUSEHOLD_TRIGGER: "DELETE_HOUSEHOLD_TRIGGER",
  DELETE_HOUSEHOLD_SUCCESS: "DELETE_HOUSEHOLD_SUCCESS",
  DELETE_HOUSEHOLD_ERROR: "DELETE_HOUSEHOLD_ERROR",
  GET_PERIODICITY_TRIGGER: "GET_PERIODICITY_TRIGGER",
  EXPORT_HOUSEHOLDS_TRIGGER: "EXPORT_HOUSEHOLDS_TRIGGER",
  EXPORT_HOUSEHOLDS_SUCCESS: "EXPORT_HOUSEHOLDS_SUCCESS",
  EXPORT_HOUSEHOLDS_ERROR: "EXPORT_HOUSEHOLDS_ERROR",
  IMPORT_HOUSEHOLDS_TRIGGER: "IMPORT_HOUSEHOLDS_TRIGGER",
  IMPORT_HOUSEHOLDS_SUCCESS: "IMPORT_HOUSEHOLDS_SUCCESS",
  IMPORT_HOUSEHOLDS_ERROR: "IMPORT_HOUSEHOLDS_ERROR",
  IMPORT_PREVIEW_TRIGGER: "IMPORT_PREVIEW_TRIGGER",
  IMPORT_PREVIEW_SUCCESS: "IMPORT_PREVIEW_SUCCESS",
  IMPORT_PREVIEW_ERROR: "IMPORT_PREVIEW_ERROR",
  SET_COLUMN_MAPPING: "SET_COLUMN_MAPPING",
  CLEAR_IMPORT_PREVIEW: "CLEAR_IMPORT_PREVIEW",
  GET_HOUSEHOLDS_CATEGORIES_TRIGGER: "GET_HOUSEHOLDS_TRIGGER",
  GET_PERIODICITY: "GET_PERIODICITY",
  GET_HOUSEHOLDS: "GET_HOUSEHOLDS",
  GET_HOUSEHOLD: "GET_HOUSEHOLD",
  UPDATE_HOUSEHOLD_SUCCESS: "UPDATE_HOUSEHOLD_SUCCESS",
  UPDATE_HOUSEHOLD_ERROR: "UPDATE_HOUSEHOLD_ERROR",
  CREATE_HOUSEHOLD: "CREATE_HOUSEHOLD",
  CREATE_HOUSEHOLD_SUCCESS: "CREATE_HOUSEHOLD_SUCCESS",
  CREATE_HOUSEHOLD_ERROR: "CREATE_HOUSEHOLD_ERROR",
  CREATE_REGULAR_CATEGORY: "CREATE_REGULAR_CATEGORY",
  DELETE_REGULAR_CATEGORY: "DELETE_REGULAR_CATEGORY",
  DELETE_HOUSEHOLDS_BY_IDS: "DELETE_HOUSEHOLDS_BY_IDS",
  DELETE_HOUSEHOLDS_BY_IDS_SUCCESS: "DELETE_HOUSEHOLDS_BY_IDS_SUCCESS",
  DELETE_HOUSEHOLDS_BY_IDS_ERROR: "DELETE_HOUSEHOLDS_BY_IDS_ERROR",
  DELETE_ALL_HOUSEHOLDS_EXCLUDE_IDS: "DELETE_ALL_HOUSEHOLDS_EXCLUDE_IDS",
  DELETE_ALL_HOUSEHOLDS_EXCLUDE_IDS_SUCCESS: "DELETE_ALL_HOUSEHOLDS_EXCLUDE_IDS_SUCCESS",
  DELETE_ALL_HOUSEHOLDS_EXCLUDE_IDS_ERROR: "DELETE_ALL_HOUSEHOLDS_EXCLUDE_IDS_ERROR",
  REMOVE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS: "REMOVE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS",
  REMOVE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS_SUCCESS: "REMOVE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS_SUCCESS",
  REMOVE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS_ERROR: "REMOVE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS_ERROR",
  REMOVE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS: "REMOVE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS",
  REMOVE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_SUCCESS: "REMOVE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_SUCCESS",
  REMOVE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_ERROR: "REMOVE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_ERROR",
  UPDATE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS: "UPDATE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS",
  UPDATE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS_SUCCESS: "UPDATE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS_SUCCESS",
  UPDATE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS_ERROR: "UPDATE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS_ERROR",
  UPDATE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS: "UPDATE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS",
  UPDATE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_SUCCESS: "UPDATE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_SUCCESS",
  UPDATE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_ERROR: "UPDATE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_ERROR",
  UPDATE_SCHEDULING_FOR_HOUSEHOLDS_BY_IDS: "UPDATE_SCHEDULING_FOR_HOUSEHOLDS_BY_IDS",
  UPDATE_SCHEDULING_FOR_HOUSEHOLDS_BY_IDS_SUCCESS: "UPDATE_SCHEDULING_FOR_HOUSEHOLDS_BY_IDS_SUCCESS",
  UPDATE_SCHEDULING_FOR_HOUSEHOLDS_BY_IDS_ERROR: "UPDATE_SCHEDULING_FOR_HOUSEHOLDS_BY_IDS_ERROR",
  UPDATE_SCHEDULING_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS: "UPDATE_SCHEDULING_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS",
  UPDATE_SCHEDULING_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_SUCCESS: "UPDATE_SCHEDULING_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_SUCCESS",
  UPDATE_SCHEDULING_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_ERROR: "UPDATE_SCHEDULING_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS_ERROR",
  UPDATE_REGULAR_CATEGORY: "UPDATE_REGULAR_CATEGORY",
  UPDATE_REGULAR_CATEGORY_SUCCESS: "UPDATE_REGULAR_CATEGORY_SUCCESS",
  UPDATE_REGULAR_CATEGORY_ERROR: "UPDATE_REGULAR_CATEGORY_ERROR",
  GET_HOUSEHOLDS_CATEGORIES: "GET_HOUSEHOLDS_CATEGORIES",
  TOGGLE_IS_LOADING: "TOGGLE_IS_LOADING",
  TOGGLE_IS_LOADING_DOWNLOAD: "TOGGLE_IS_LOADING_DOWNLOAD",
}

type InitialState = {
  households: Households | null
  householdsMap: Households | null
  households_for_download: Households | null
  // The full, unpaginated contact book downloaded by the offline "Download for
  // offline" prefetch (src/offline/prefetch.ts) — plain array, not the
  // paginated `{data, links, meta}` envelope `households` holds. Kept as a
  // SEPARATE field on purpose: `households` is written wholesale by every
  // GET_HOUSEHOLDS dispatch (25 rows at a time from ContactsPage's normal
  // server-paginated fetch), which would otherwise clobber a 3,000-row
  // snapshot with whatever page happened to be cached. Only ContactsPage's
  // offline branch reads this; every other GET_HOUSEHOLDS consumer is
  // untouched. See ContactsPage/index.tsx.
  offlineSnapshot: any[] | null
  // Full per-household detail for the whole workspace, keyed by id, written only by
  // the "Download for offline" prefetch. The contact card, the edit form and the
  // visit-report wizard all read `household`, which is filled by a per-household
  // request — a URL nothing else warms, so offline it is a cache miss for every
  // household whose card was never opened. This is what the reducer serves instead.
  // A map rather than an array: the lookup is by id, on every card open.
  offlineHouseholdDetails: Record<number, any>
  categories: null,
  periodicity: null
  household: null
  csvFile: null
  isLoading: boolean
  isLoadingDownload: boolean
  importHeaders: string[]
  importPreviewRows: string[][]
  importRowCount: number
  columnMapping: Record<string, string>
  importPreviewLoading: boolean
  // Bumped whenever a household's address may have changed in a way that affects the map (a
  // direct edit, or an admin confirming a staged Left Town / Update Contact Info address) — see
  // HomePage.tsx, which watches this to force a fresh map fetch instead of waiting for the next
  // pan (households-for-map is cached client-side, so a stale entry can otherwise sit for a while).
  householdsMapRefreshToken: number
  /** Which map request "generation" householdsMap belongs to — see the SUCCESS case. */
  householdsMapGeneration: number
  /** True when the latest refresh-token bump only ADDS pins (background geocoding), so
   *  HomePage may merge the refetch; false for edits/confirmations, which can move or
   *  remove a pin and therefore replace. */
  householdsMapRefreshAddsOnly: boolean
}

const initialState: InitialState = {
  households: null,
  categories: null,
  household: null,
  households_for_download: null,
  offlineSnapshot: null,
  offlineHouseholdDetails: {},
  periodicity: null,
  csvFile: null,
  householdsMap: null,
  isLoading: false,
  isLoadingDownload: false,
  importHeaders: [],
  importPreviewRows: [],
  importRowCount: 0,
  columnMapping: {},
  importPreviewLoading: false,
  householdsMapRefreshToken: 0,
  householdsMapGeneration: 0,
  householdsMapRefreshAddsOnly: false,
}

export const householdsReducer = (state = initialState, action: Actions) => {
  switch (action.type) {
    case actionTypes.GET_HOUSEHOLDS_TRIGGER_FOR_MAP_SUCCESS: {
      // HomePage tags every map request with a generation (bumped whenever the filters,
      // project or forced refresh change what the map should show) and whether it is a
      // same-filters viewport refetch. A refetch is MERGED into the list (never drops
      // markers → no full marker rebuild per zoom); a response from an older generation
      // arriving late is ignored instead of overwriting newer results.
      const meta = (action as any).meta || {};
      const generation = meta.mapGeneration;
      if (typeof generation !== "number") {
        return { ...state, householdsMap: action.payload };
      }
      if (generation < state.householdsMapGeneration) {
        return state;
      }
      if (meta.mergeMap && generation === state.householdsMapGeneration && state.householdsMap?.data) {
        return {
          ...state,
          householdsMap: {
            ...(action.payload as any),
            data: mergeMapHouseholds(state.householdsMap.data as any, (action.payload as any)?.data),
          },
        };
      }
      return { ...state, householdsMap: action.payload, householdsMapGeneration: generation };
    }

    case actionTypes.GET_HOUSEHOLDS:
      return { ...state, households: action.payload }

    // Deliberately separate from GET_HOUSEHOLDS above — see the `offlineSnapshot`
    // field comment. Nothing else in the app dispatches this but the offline
    // prefetch engine, and nothing else reads it but ContactsPage's offline branch.
    case actionTypes.SET_HOUSEHOLDS_OFFLINE_SNAPSHOT:
      return { ...state, offlineSnapshot: action.payload }

    case actionTypes.GET_HOUSEHOLDS_FOR_DOWNLOAD:
      return { ...state, households_for_download: action.payload }

    case actionTypes.GET_HOUSEHOLD:
      return { ...state, household: action.payload }

    // Full details for the whole workspace, keyed by id — see the field comment.
    case actionTypes.SET_HOUSEHOLD_DETAILS_OFFLINE_SNAPSHOT:
      return {
        ...state,
        offlineHouseholdDetails: (action.payload ?? []).reduce(
          (acc: Record<number, any>, household: any) => {
            if (household?.id != null) acc[household.id] = household;
            return acc;
          },
          {} as Record<number, any>
        ),
      }

    // One household re-pulled after its queued edit reached the server. Only that
    // entry changes: the rest of the downloaded copy is still good, and re-running
    // the whole download to correct one contact is what this replaced.
    case actionTypes.MERGE_HOUSEHOLD_DETAIL: {
      const fresh = action.payload
      if (!fresh?.id) return state
      return {
        ...state,
        offlineHouseholdDetails: { ...state.offlineHouseholdDetails, [fresh.id]: fresh },
      }
    }

    // The live per-household fetch could not run. Serve the downloaded copy, and
    // when there isn't one, clear the field: leaving the PREVIOUS household in
    // place is how a contact card spins forever and how a report wizard reads
    // someone else's contacts.
    case actionTypes.USE_OFFLINE_HOUSEHOLD:
      return {
        ...state,
        household: state.offlineHouseholdDetails?.[action.payload] ?? null,
      }

    case actionTypes.UPDATE_HOUSEHOLD_SUCCESS: {
      const updated = action.payload?.data;
      const patchedHouseholds = !state.households?.data || !updated?.id
        ? state.households
        : {
            ...state.households,
            data: state.households.data.map((h: any) =>
              h.id === updated.id ? { ...h, householdName: updated.householdName, imported_name: updated.imported_name } : h
            ),
          };
      return {
        ...state,
        households: patchedHouseholds,
        householdsMapRefreshToken: state.householdsMapRefreshToken + 1,
        householdsMapRefreshAddsOnly: false,
      };
    }

    // An admin confirming a staged Left Town move or an Update-Contact-Info home-address
    // correction also changes a household's address — the map must refresh just like a direct
    // edit. These action types are dispatched from notificationsReducer.tsx's saga flows; matched
    // here by their literal string (reducers only care about action.type, not which file owns it).
    case 'CONFIRM_ADDRESS_NOTIFICATION_SUCCESS':
    case 'CONFIRM_UPDATE_UPDATED_PERSONS_SUCCESS':
      return { ...state, householdsMapRefreshToken: state.householdsMapRefreshToken + 1, householdsMapRefreshAddsOnly: false };

    // Background geocoding finished more addresses while the map sat open — pins that
    // did not exist at fetch time now do. It only ever ADDS pins, so HomePage merges
    // the refetch rather than rebuilding every marker every 15 seconds.
    case actionTypes.REFRESH_MAP_PINS:
      return { ...state, householdsMapRefreshToken: state.householdsMapRefreshToken + 1, householdsMapRefreshAddsOnly: true };

    case actionTypes.GET_PERIODICITY:
      return { ...state, periodicity: action.payload }

    case actionTypes.GET_HOUSEHOLDS_CATEGORIES:
      return { ...state, categories: action.payload }

    case actionTypes.TOGGLE_IS_LOADING:
      return { ...state, isLoading: action.payload }

    case actionTypes.TOGGLE_IS_LOADING_DOWNLOAD:
      return { ...state, isLoadingDownload: action.payload }

    case actionTypes.IMPORT_PREVIEW_TRIGGER:
      return { ...state, importPreviewLoading: true }

    case actionTypes.IMPORT_PREVIEW_SUCCESS:
      return {
        ...state,
        importPreviewLoading: false,
        importHeaders: action.payload.headers,
        importPreviewRows: action.payload.rows,
        importRowCount: action.payload.row_count,
      }

    case actionTypes.IMPORT_PREVIEW_ERROR:
      return { ...state, importPreviewLoading: false }

    case actionTypes.SET_COLUMN_MAPPING:
      return { ...state, columnMapping: action.payload }

    case actionTypes.CLEAR_IMPORT_PREVIEW:
      return {
        ...state,
        importHeaders: [],
        importPreviewRows: [],
        importRowCount: 0,
        columnMapping: {},
        importPreviewLoading: false,
      }

    default:
      return state
  }
}

export const householdsActions = {
  getHouseholdsAC: (data: any) => ({
    type: actionTypes.GET_HOUSEHOLDS,
    payload: data,
  }),
  getHouseholdAC: (data: any) => ({
    type: actionTypes.GET_HOUSEHOLD,
    payload: data,
  }),

  getHouseholdCategories: (data: any) => ({
    type: actionTypes.GET_HOUSEHOLDS_CATEGORIES,
    payload: data,
  }),

  getHouseholdsDownloadAC: (data: any) => ({
    type: actionTypes.GET_HOUSEHOLDS_FOR_DOWNLOAD,
    payload: data,
  }),

  setHouseholdDetailsOfflineSnapshotAC: (data: any[]) => ({
    type: actionTypes.SET_HOUSEHOLD_DETAILS_OFFLINE_SNAPSHOT,
    payload: data,
  } as const),

  /** Replace one household in the downloaded copy, after it synced. */
  mergeHouseholdDetailAC: (household: any) => ({
    type: actionTypes.MERGE_HOUSEHOLD_DETAIL,
    payload: household,
  } as const),

  /** Fall back to the downloaded copy when the live fetch could not run. */
  useOfflineHouseholdAC: (id: number) => ({
    type: actionTypes.USE_OFFLINE_HOUSEHOLD,
    payload: id,
  } as const),

  setHouseholdsOfflineSnapshotAC: (data: any[]) => ({
    type: actionTypes.SET_HOUSEHOLDS_OFFLINE_SNAPSHOT,
    payload: data,
  }),

  getPeriodicityAC: (data: any) => ({
    type: actionTypes.GET_PERIODICITY,
    payload: data,
  }),

  // payload: null rather than omitted — the Actions union is derived from the
  // return types in this object, and a member without `payload` narrows the
  // whole union so every other case loses access to it.
  refreshMapPinsAC: () => ({ type: actionTypes.REFRESH_MAP_PINS, payload: null }),
  getHouseholdsForMap: (data: any) => ({
    type: actionTypes.GET_HOUSEHOLDS_TRIGGER_FOR_MAP_SUCCESS,
    payload: data,
  }),

  toggleIsLoading: (data: any) => ({
    type: actionTypes.TOGGLE_IS_LOADING,
    payload: data,
  }),

  toggleIsLoadingDownload: (data: any) => ({
    type: actionTypes.TOGGLE_IS_LOADING_DOWNLOAD,
    payload: data,
  }),
}

export const importPreviewActions = {
  importPreviewTrigger: (file: File) => ({
    type: actionTypes.IMPORT_PREVIEW_TRIGGER,
    payload: { file },
  }),
  setColumnMapping: (mapping: Record<string, string>) => ({
    type: actionTypes.SET_COLUMN_MAPPING,
    payload: mapping,
  }),
  clearImportPreview: () => ({
    type: actionTypes.CLEAR_IMPORT_PREVIEW,
  }),
}

export const householdsTriggerActions = {
  getHouseholdsTriggerAC: ({ page, perPage, mainPersonFullName, sortOrder, search, sortBy, address_longitude_max, address_latitude_max, address_latitude_min, address_longitude_min }: GetHouseholds) => ({
    type: actionTypes.GET_HOUSEHOLDS_TRIGGER,
    payload: {
      page,
      perPage,
      mainPersonFullName,
      sortBy,
      sortOrder,
      address_longitude_min,
      address_latitude_min,
      address_longitude_max,
      address_latitude_max,
      ...search,
    }
  }),

  getHouseholdsDownloadTriggerAC: ({ page, mainPersonFullName, sortOrder, search, sortBy, address_longitude_max, address_latitude_max, address_latitude_min, address_longitude_min }: GetHouseholds) => ({
    type: actionTypes.GET_HOUSEHOLDS_FOR_DOWNLOAD_TRIGGER,
    payload: {
      page,
      perPage: undefined,
      mainPersonFullName,
      sortBy,
      sortOrder,
      address_longitude_min,
      address_latitude_min,
      address_longitude_max,
      address_latitude_max,
      ...search,
    }
  }),

  getHouseholdsCategories: () => ({
    type: actionTypes.GET_HOUSEHOLDS_CATEGORIES_TRIGGER,
  }),

  createHouseholdCategory: (name: string) => ({
    type: actionTypes.CREATE_REGULAR_CATEGORY,
    name
  }),

  deleteHouseholdCategory: (id: number) => ({
    type: actionTypes.DELETE_REGULAR_CATEGORY,
    id
  }),

  deleteHouseholdsByIds: (ids: number[]) => ({
    type: actionTypes.DELETE_HOUSEHOLDS_BY_IDS,
    ids
  }),

  deleteAllHouseholdsExcludeIds: (excludedIds: number[]) => ({
    type: actionTypes.DELETE_ALL_HOUSEHOLDS_EXCLUDE_IDS,
    excludedIds,
  }),

  updateRegularCategoriesForHouseholdsByIds: (ids: number[], category_ids: number[]) => ({
    type: actionTypes.UPDATE_REGULAR_CATEGORIES_FOR_HOUSEHOLDS_BY_IDS,
    ids,
    category_ids
  }),

  updateRegularCategoriesForAllHouseholdsExcludeIds: (excludedIds: number[], category_ids: number[]) => ({
    type: actionTypes.UPDATE_REGULAR_CATEGORIES_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS,
    excludedIds,
    category_ids
  }),

  updateSchedulingForHouseholdsByIds: (ids: number[], periodicity: string) => ({
    type: actionTypes.UPDATE_SCHEDULING_FOR_HOUSEHOLDS_BY_IDS,
    ids,
    periodicity,
  }),

  updateSchedulingForAllHouseholdsExcludeIds: (excludedIds: number[], periodicity: string) => ({
    type: actionTypes.UPDATE_SCHEDULING_FOR_ALL_HOUSEHOLDS_EXCLUDE_IDS,
    excludedIds,
    periodicity,
  }),

  updateHouseholdCategory: (id: number, name: string) => ({
    type: actionTypes.UPDATE_REGULAR_CATEGORY,
    id,
    name
  }),

  getHouseholdTriggerAC: (id: number) => ({
    type: actionTypes.GET_HOUSEHOLD_TRIGGER,
    id,
  }),

  getPeriodicityTriggerAC: () => ({
    type: actionTypes.GET_PERIODICITY_TRIGGER,
  }),
}

export type Actions = InferActionsTypes<typeof householdsActions>
